// eslint-disable-next-line max-len
import Joi from 'joi-full';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import withPropsOnChange from 'recompose/withPropsOnChange';
import { clearPayingObject } from '../../../main/payment/actions';
import { syncValidateData } from '../../../common/validator';
import { hideReceipt, sendReceipt } from '../actions';
import {
  getEmail,
  getError,
  getLoading,
  getPhone,
  getIsLinkInSmsSupported,
  getTotalForReceipt,
} from '../selectors';
import Receipt from '../components/Receipt';
import withPermissions from '../../../auth/utils/withPermissions';
import { canUserViewAppointmentContactInfo } from '../../../common/helpers/users';

// eslint-disable-next-line
const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const phoneRegex = /^\+?\d{0,3}[- ]?\(?\d{1,4}\)?[- ]?\d{2,5}[- ]?\d{2,5}$/;
const phoneSchema = Joi.string()
  .regex(phoneRegex)
  .required();
const emailSchema = Joi.string()
  .regex(emailRegex)
  .required();

const ReceiptContainer = compose(
  withPermissions,
  connect(
    (state, ownProps) => ({
      customerPhone: canUserViewAppointmentContactInfo(state.auth.permissions) ? getPhone(state) : '',
      customerEmail: canUserViewAppointmentContactInfo(state.auth.permissions) ? getEmail(state) : '',
      transactionIdentifier: ownProps.params.transactionIdentifier,
      total: getTotalForReceipt(state),
      loading: getLoading(state),
      error: getError(state),
      shouldShowSms: getIsLinkInSmsSupported(state),
    }),
    { hideReceipt, sendReceipt, clearPayingObject }
  ),
  withState('email', 'setEmail', props => props.customerEmail || ''),
  withState('phone', 'setPhone', props => props.customerPhone || ''),
  withState(
    'phoneValid',
    'setPhoneValid',
    props => syncValidateData(props.phone, phoneSchema) === true
  ),
  withState(
    'emailValid',
    'setEmailValid',
    props => syncValidateData(props.email, emailSchema) === true
  ),
  withHandlers({
    sendReceipt: props => params =>
      props.sendReceipt({
        customerId: props.customerId,
        transactionIdentifier: props.transactionIdentifier,
        ...params,
      }),
    validateEmail: props => value => props.setEmailValid(
      syncValidateData(value, emailSchema) === true
    ),
    validatePhone: props => value => props.setPhoneValid(
      syncValidateData(value, phoneSchema) === true
    ),
  }),
  withPropsOnChange(
    // Fix race condition when customerEmail/phone is not always received at first mount
    ['customerPhone', 'customerEmail'],
    (props) => {
      props.setEmail(props.customerEmail);
      props.setPhone(props.customerPhone);
      props.validateEmail(props.customerEmail);
      props.validatePhone(props.customerPhone);
    },
  ),
  withHandlers({
    onEmailChange: props => (e) => {
      props.setEmail(e.target.value);
      return props.validateEmail(e.target.value);
    },
    onPhoneChange: props => (value) => {
      props.setPhone(value);
      return props.validatePhone(value);
    },
    onNoReceipt: props => () => {
      props.hideReceipt();
      return props.clearPayingObject();
    },
    submitPhone: props => (e) => {
      e.preventDefault();
      props.sendReceipt({ phone: props.phone });
    },
    submitEmail: props => (e) => {
      e.preventDefault();
      props.sendReceipt({ email: props.email });
    },
  })
)(Receipt);

export default ReceiptContainer;
